import React, { useEffect, useState } from 'react'
import { useAxios } from '../../../hooks/useAxios';
import { useTranslation } from "react-i18next";

export const useLibros = ( {counter = 0, books} ) => {
    const [t, i18n] = useTranslation("biblioteca");

    const [libros, setLibros] = useState( books );
    const [url = `/library/nbooks2?offset=0&next=12&sitioid=2&lenguaje=${i18n.language}`, setUrl] = useState(null)
    
    const { data, isLoading, error } = useAxios(url);

    useEffect(() => {
        if(data){
            setLibros( data );
        }else {
        }
    }, [data]);
    
    useEffect(() => {
        if(counter > 0) {
            setUrl(`/library/nbooks2?offset=${ counter * 12 }&next=12&sitioid=2&lenguaje=${i18n.language}`);
        }else {
            setLibros( books );
            setUrl(`/library/nbooks2?offset=0&next=12&sitioid=2&lenguaje=${i18n.language}`);
        }
    },[counter, i18n.language]);



    return {
        libros,
        isLoading,
        error,
    };
}

export const useLibros_Mov = ( {counter = 0, books} ) => {
    const [t, i18n] = useTranslation("biblioteca");
    
    const [libros_mov, setLibros] = useState( books );
    const [url = `/library/nbooks2?offset=0&next=6&sitioid=2&lenguaje=${i18n.language}`, setUrl] = useState(null)
    
    const { data, isLoading_mov, error_mov } = useAxios(url);

    useEffect(() => {
        if(data){
            setLibros( data );
        }else {
        }
    }, [data]);
    
    useEffect(() => {
        if(counter > 0) {
            setUrl(`/library/nbooks2?offset=${ counter * 6 }&next=6&sitioid=2&lenguaje=${i18n.language}`);
        }else {
            setLibros( books );
            setUrl(`/library/nbooks2?offset=0&next=6&sitioid=2&lenguaje=${i18n.language}`);
        }
    },[counter, i18n.language]);



    return {
        libros_mov,
        isLoading_mov,
        error_mov,
    };
}

